// Debug service for development mode
const isDebugMode = typeof __DEBUG_MODE__ !== 'undefined' ? __DEBUG_MODE__ : false;

// Mock user accounts for testing
export const mockUsers = {
  member: {
    id: 'mock-user-1',
    name: 'John Doe',
    initials: 'JD',
    email: 'john.doe@example.com',
    is_member: true,
    is_first_time_lezioni: false,
    current_lesson_slug: 'introduction-to-alchemy',
    current_degree_slug: 'neophyte'
  },
  firstTimeUser: {
    id: 'mock-user-2', 
    name: 'Jane Smith',
    initials: 'JS',
    email: 'jane.smith@example.com',
    is_member: true,
    is_first_time_lezioni: true,
    current_lesson_slug: 'welcome-lesson',
    current_degree_slug: 'neophyte'
  },
  nonMember: {
    id: 'mock-user-3',
    name: 'Bob Wilson',
    initials: 'BW', 
    email: 'bob.wilson@example.com',
    is_member: false,
    is_first_time_lezioni: false,
    current_lesson_slug: null,
    current_degree_slug: null
  }
};

// Debug session management
export const debugAuth = {
  // Create a mock session for a user
  loginUser: (userType) => {
    if (!isDebugMode) return false;
    
    const user = mockUsers[userType];
    if (!user) return false;
    
    // Create a mock session ID
    const mockSessionId = `debug-session-${userType}-${Date.now()}`;
    localStorage.setItem('sessionId', mockSessionId);
    localStorage.setItem('debugUser', JSON.stringify(user));
    
    return true;
  },
  
  // Clear debug session
  logout: () => {
    if (!isDebugMode) return false;
    
    localStorage.removeItem('sessionId');
    localStorage.removeItem('debugUser');
    return true;
  },
  
  // Get current debug user
  getCurrentUser: () => {
    if (!isDebugMode) return null;
    
    const debugUser = localStorage.getItem('debugUser');
    return debugUser ? JSON.parse(debugUser) : null;
  },
  
  // Check if we're in a debug session
  isDebugSession: () => {
    if (!isDebugMode) return false;
    
    const sessionId = localStorage.getItem('sessionId');
    return sessionId && sessionId.startsWith('debug-session-');
  }
};

export { isDebugMode };
